export default "__VITE_ASSET__09089024__$_?component__"